import AddressInfo from '@porterin/component-library/src/composite-components/address-summary/addressInfo';
import { IMAGES } from '@porterin/component-library/src/composite-components/address-summary/store';
import Image from 'next/image';
import React from 'react';

export interface CustomerAddress {
  name: string;
  phone: string;
  address: string;
}

export interface AddressSummaryProps {
  sender: CustomerAddress;
  receiver: CustomerAddress;
  showEditButton: boolean;
}

const AddressSummary: React.FC<AddressSummaryProps> = ({
  sender,
  receiver,
  showEditButton,
}) => {
  const onEditClick = () => {
    // TODO: Handle edit click
  };

  return (
    <div className="flex rounded-2xl p-6 shadow-md w-full space-x-6 items-center">
      <div className="flex flex-col items-center h-full justify-between">
        <Image
          src={IMAGES.PICKUP.src}
          alt={IMAGES.PICKUP.alt}
          width={10}
          height={10}
        />
        <Image
          src={IMAGES.DOTTED_CONNECTOR.src}
          alt={IMAGES.DOTTED_CONNECTOR.alt}
          width={2}
          height={80}
          className="h-24"
        />
        <Image
          src={IMAGES.DROP.src}
          alt={IMAGES.DROP.alt}
          width={12}
          height={14}
        />
      </div>
      <div className="flex flex-col flex-1 text-black font-normal space-y-10">
        <AddressInfo
          name={sender.name}
          phone={sender.phone}
          address={sender.address}
          showEditButton={showEditButton}
          onEdit={onEditClick}
        />
        <AddressInfo
          name={receiver.name}
          phone={receiver.phone}
          address={receiver.address}
          showEditButton={showEditButton}
          onEdit={onEditClick}
        />
      </div>
    </div>
  );
};

export default AddressSummary;
